module.exports = __webpack_public_path__ + "img/10_37.49da94a2.png";